import { REPORT_SCHEDULE_COMPLETED, REPORT_SCHEDULE_FAILED, REPORT_SCHEDULE_PARTIAL_COMPLETED, REPORT_SCHEDULE_PENDING, REPORT_SCHEDULE_RUNNING, DATATABLE_ALL, REPORT_AUTOMATION_ACTIVE, REPORT_AUTOMATION_DELETED, REPORT_AUTOMATION_INACTIVE } from './constants';
import { printThis } from './main';
import { ajaxPromise, checkChosenChanged, confirmDialog, displayNotification, dtColumnIndicies, getDateFilter, getDtRowData, htmlEsc, initDateFilter, logerror, post, toggleSlide } from './utils';

const initReportAutomation = () => {
	let automationsDt: DataTables.Api;
	const automationData = JSON.parse(atob($('#automation_form').data('js')));

	const initAutomationsTable = () => {
		const columns: DataTables.ColumnSettings[] = [
			{
				title: 'Name',
				data: 'ra_name',
			},
			{
				title: 'Cadence',
				data: 'ra_preview_msg',
			},
			{
				title: 'Recipients',
				data: 'ra_to',
				render: (data: string) => {
					const emails = data.split(/[,\n]/).map(email => email.trim()).filter(email => email);
					if (emails.length <= 2) {
						return emails.join(', ');
					}
					return `${emails.slice(0, 2).join(', ')} <em>(+${emails.length - 2} more)</em>`;
				},
			},
			{
				title: 'Status',
				data: 'ra_status_pretty',
			},
			{
				title: 'Created',
				data: 'ra_createdate_pretty',
			},
			{
				title: 'Actions',
				data: null,
				orderable: false,
				searchable: false,
				render: (_data: unknown, _type: string, row: { ra_status: number | string }) => {
					const status = Number(row.ra_status);
					const isDeleted = status === REPORT_AUTOMATION_DELETED;
					return `
					<div>
						${!isDeleted ? `
						<button type="button" class="btn btn-xs btn-primary automation_edit" title="Edit">
							<i class="fa fa-edit"></i>
						</button>
						` : ''}
						<button type="button" class="btn btn-xs btn-info automation_schedule" title="View Schedule">
							<i class="fa fa-clock"></i>
						</button>
						${status === REPORT_AUTOMATION_ACTIVE ? `
						<button type="button" class="btn btn-xs btn-success automation_run" title="Run">
							<i class="fa fa-play"></i>
						</button>
						` : ''}
						${!isDeleted ? `
						<button type="button" class="btn btn-xs btn-danger automation_delete" title="Delete">
							<i class="fa fa-trash"></i>
						</button>
						` : ''}
					</div>
				`;
				},
			},
		];
		const columnIndicies = dtColumnIndicies(columns);

		const getAutomationFilters = () => ({
			status: $('#report_automation_filter_status').val() as string[],
		});

		const dtOptions: DataTables.Settings = {
			ajax: {
				url: '/data/report_automations_load',
				data: (postData: any) => ({
					...postData,
					report_id: automationData.reportId,
					filters: getAutomationFilters(),
				}),
			},
			buttons: [
				{
					text: '<i class="fa fa-plus me-2"></i> Add Automation',
					className: 'btn btn-sm btn-success',
					action: () => showAutomationForm(),
				},
				{
					text: '<i class="fa fa-file-csv me-2"></i> Export',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const $btn = $(target);
						$btn.prop('disabled', true);

						post('/export', {
							type: 'report_automation',
							data: JSON.stringify({
								report_id: automationData.reportId,
								filters: getAutomationFilters(),
							}),
						});

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
				{
					text: '<i class="fa fa-print me-2"></i> Print',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const $btn = $(target);
						$btn.prop('disabled', true);

						const params = {
							...automationsDt.ajax.params(),
							report_id: automationData.reportId,
							filters: getAutomationFilters(),
						};

						post('/printout/report_automation', {
							params: JSON.stringify(params)
						}, '_blank');

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
			],
			columns,
			language: {
				emptyTable: `
					<div class="text-center" style="padding: 40px;">
						<i class="fa fa-clock-o fa-3x text-muted" style="margin-bottom: 20px;"></i>
						<h4>No Automations</h4>
						<button type="button" class="btn btn-success btn-md" onclick="showAutomationForm()">
							<i class="fa fa-plus me-2"></i> Create Automation
						</button>
					</div>
				`,
			},
			order: [[columnIndicies.ra_createdate_pretty, 'desc']],
		};

		automationsDt = $('#automations_table').DataTable(dtOptions);

		// Filter functionality
		const defaultAutomationStatuses = [
			String(REPORT_AUTOMATION_ACTIVE),
			String(REPORT_AUTOMATION_INACTIVE),
		];
		const checkAutomationFiltersChosenChanged = () => $('#report_automation_filter_container select.chosen').each((_, element) => checkChosenChanged($(element)));

		$('#report_automation_filter_container select.chosen').on('change', () => {
			checkAutomationFiltersChosenChanged();
			automationsDt.ajax.reload();
		});

		$('#report_automation_filter_toggle').on('click', () => {
			$('#report_automation_filter_container').slideToggle();
			const $icon = $('#report_automation_filter_toggle i');
			$icon.toggleClass('fa-caret-down fa-caret-up');
		});

		$('#report_automation_filter_reset').on('click', () => {
			($('#report_automation_filter_container')[0] as HTMLFormElement).reset();
			$('#report_automation_filter_status')
				.val(defaultAutomationStatuses)
				.trigger('chosen:updated');
			checkAutomationFiltersChosenChanged();
			automationsDt.ajax.reload();
		});

		// Initialize chosen dropdowns
		$('#report_automation_filter_container select.chosen').chosen({
			width: '100%',
			search_contains: true,
		});

		$('#report_automation_filter_status')
			.val(defaultAutomationStatuses)
			.trigger('chosen:updated');

		checkAutomationFiltersChosenChanged();

		$('#automations_table').on('click', '.automation_edit', ({ target }) => {
			const rowData = getDtRowData(automationsDt, target)
			showAutomationForm(rowData);
		});

		$('#automations_table').on('click', '.automation_schedule', ({ target }) => {
			const rowData = getDtRowData(automationsDt, target)
			showScheduleModal(rowData.ra_id);
		});

		$('#automations_table').on('click', '.automation_run', ({ target }) => {
			const rowData = getDtRowData(automationsDt, target)
			runAutomation(rowData.ra_id);
		});

		$('#automations_table').on('click', '.automation_delete', ({ target }) => {
			const rowData = getDtRowData(automationsDt, target);
			deleteAutomation(rowData);
		});
	};

	const formatDate = (dateString: string) => {
		const [year, month, day] = dateString.split('-');
		const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
		return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
	}

	const formatTime = (timeString: string) => {
		const [hour, minute] = timeString.split(':');
		const date = new Date();
		date.setHours(parseInt(hour), parseInt(minute));
		return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
	}

	// Handle recurrence type changes
	$('#ra_recurrence_type').on('change', ({ target }) => {
		const recurrenceType = $(target).val();

		if (recurrenceType === 'none') {
			$('#on_section, #end_section').hide();
			$('#day_of_month_option, #days_of_week_option, #months_option').hide();
		} else if (['minute', 'hour', 'day'].includes(recurrenceType)) {
			$('#on_section').hide();
			$('#end_section').show();
		} else {
			$('#on_section, #end_section').show();

			$('#day_of_month_option, #days_of_week_option, #months_option').hide();
			switch (recurrenceType) {
				case 'week':
					$('#days_of_week_option').show();
					break;
				case 'month':
					$('#day_of_month_option').show();
					break;
				case 'year':
					$('#months_option').show();
					break;
			}
		}

		updateSchedulePreview();
	});

	// Handle weekly pattern changes
	$('input[name="weekly_pattern"]').on('change', ({ target }) => {
		const pattern = $(target).val();

		if (pattern === 'same_day') {
			$('#specific_days_checkboxes').hide();
			$('input[name="ra_recurrence_days[]"]').prop('checked', false);
		} else {
			$('#specific_days_checkboxes').show();
		}

		updateSchedulePreview();
	});

	// Handle monthly pattern changes
	$('input[name="monthly_pattern"]').on('change', ({ target }) => {
		const pattern = $(target).val();

		$('#specific_dates_container, #day_of_week_pattern_container').hide();

		if (pattern === 'specific_dates') {
			$('#specific_dates_container').show();
		} else if (pattern === 'day_of_week') {
			$('#day_of_week_pattern_container').show();
		}

		updateSchedulePreview();
	});

	// Handle yearly pattern changes
	$('input[name="yearly_pattern"]').on('change', ({ target }) => {
		const pattern = $(target).val();

		$('#yearly_specific_dates_container').hide();

		if (pattern === 'specific_dates') {
			$('#yearly_specific_dates_container').show();
		}

		updateSchedulePreview();
	});

	// Handle end pattern changes
	$('input[name="end_pattern"]').on('change', ({ target }) => {
		const pattern = $(target).val();

		$('#ra_end_date').prop('disabled', pattern !== 'end_date');
		$('#ra_max_occurrences').prop('disabled', pattern !== 'after_occurrences');

		updateSchedulePreview();
	});

	// Update interval display for weekly
	$('#ra_recurrence_interval').on('change', ({ target }) => {
		updateWeeklyIntervalDisplay();
		updateSchedulePreview();
	});

	// Update start day display for weekly
	$('#ra_start_date').on('change', ({ target }) => {
		if ($(target).val()) {
			const dateString = $(target).val() as string;
			const [year, month, day] = dateString.split('-').map(Number);
			const localDate = new Date(year, month - 1, day);
			const dayName = localDate.toLocaleDateString('en-US', { weekday: 'long' });
			$('#start_day_display').text(dayName + 's');
		}
		updateSchedulePreview();
	});

	const updateWeeklyIntervalDisplay = () => $('#weekly_interval_display').text($('#ra_recurrence_interval').val() || 1);

	const updateSchedulePreview = () => {
		const startDate = $('#ra_start_date').val() as string;
		const startTime = $('#ra_start_time').val() as string;
		const recurrenceType = $('#ra_recurrence_type').val() as string;
		const interval = parseInt($('#ra_recurrence_interval').val() as string) || 1;

		if (!startDate || !startTime) {
			$('#schedule_preview').html('<p class="text-muted" style="margin: 0;">Please set start date and time</p>');
			return;
		}

		let description = '';
		const formattedDate = formatDate(startDate);
		const formattedTime = formatTime(startTime);

		if (recurrenceType === 'none') {
			description = `Run once on ${formattedDate} at ${formattedTime}`;
		} else {
			description = `Starting ${formattedDate} at ${formattedTime}, then `;

			// Build interval description
			if (interval === 1) {
				switch (recurrenceType) {
					case 'minute': description += 'every minute'; break;
					case 'hour': description += 'every hour'; break;
					case 'day': description += 'every day'; break;
					case 'week': description += 'every week'; break;
					case 'month': description += 'every month'; break;
					case 'year': description += 'every year'; break;
				}
			} else {
				description += `every ${interval} ${recurrenceType}s`;
			}

			// Add specific pattern information
			if (recurrenceType === 'week') {
				const weeklyPattern = $('input[name="weekly_pattern"]:checked').val();
				if (weeklyPattern === 'specific_days') {
					const selectedDays = $('input[name="ra_recurrence_days[]"]:checked').map((_, element) => {
						const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
						return dayNames[parseInt($(element).val() as string)];
					}).get();

					if (selectedDays.length > 0) {
						description += ` on ${selectedDays.join(', ')}`;
					}
				} else {
					description += ` (same day as start date)`;
				}
			} else if (recurrenceType === 'month') {
				const monthlyPattern = $('input[name="monthly_pattern"]:checked').val();
				if (monthlyPattern === 'same_date') {
					description += ` (same date as start date)`;
				} else if (monthlyPattern === 'specific_dates') {
					const selectedDates = $('input[name="monthly_dates[]"]:checked').map((_, element) => $(element).val()).get();
					if (selectedDates.length > 0) {
						description += ` on the ${selectedDates.join(', ')}`;
					}
				} else if (monthlyPattern === 'day_of_week') {
					const position = $('#monthly_week_position').val();
					const dayOfWeek = $('#monthly_day_of_week option:selected').text();
					description += ` on the ${position} ${dayOfWeek}`;
				}
			} else if (recurrenceType === 'year') {
				const yearlyPattern = $('input[name="yearly_pattern"]:checked').val();
				if (yearlyPattern === 'same_date') {
					description += ` (same date as start date)`;
				} else if (yearlyPattern === 'specific_dates') {
					const selectedMonths = $('input[name="yearly_months[]"]:checked').map((_, element) => {
						const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
						return monthNames[parseInt($(element).val() as string) - 1];
					}).get();
					const yearlyDate = $('#yearly_date').val();
					if (selectedMonths.length > 0) {
						description += ` on ${selectedMonths.join(', ')} ${yearlyDate}`;
					}
				}
			}

			// Add end information
			const endPattern = $('input[name="end_pattern"]:checked').val();
			if (endPattern === 'end_date') {
				const endDate = $('#ra_end_date').val() as string;
				if (endDate) {
					description += ` until ${formatDate(endDate)} (last run)`;
				}
			} else if (endPattern === 'after_occurrences') {
				const maxOccurrences = $('#ra_max_occurrences').val();
				if (maxOccurrences) {
					description += ` for ${maxOccurrences} occurrences`;
				}
			}
		}

		$('#schedule_preview').html(`<p style="margin: 0;"><strong>${description}</strong></p>`);
	};

	// events for all form elements that affect the preview
	$('#ra_start_date, #ra_start_time, #ra_recurrence_interval').on('change', updateSchedulePreview);
	$('input[name="ra_recurrence_days[]"], input[name="monthly_dates[]"], input[name="yearly_months[]"]').on('change', updateSchedulePreview);
	$('#ra_end_date, #ra_max_occurrences, #monthly_week_position, #monthly_day_of_week, #yearly_date').on('change', updateSchedulePreview);

	const runAutomation = async (automationId: number) => {
		const confirmed = await confirmDialog({
			dialogTitle: `Run Automation`,
			bodyText: `Are you sure you would like to run this automation?`,
			confirmText: 'Submit',
			confirmStyle: 'success',
		});
		if (!confirmed) return;
		try {
			const postData = {
				type: 'report_automation_run',
				data: { automationId },
			};
			const res = await ajaxPromise('/form/submit', postData);
			if (res.rc !== 'OK') throw res;

			displayNotification(`Run Automation Success`, `The automation was run successfully.`, 'success');
		} catch (error) {
			displayNotification(`Run Automation Error`, `The automation cannot be run.`, 'danger');
			logerror('run automation', error);
		}
	};

	const resetAutomationForm = () => {
		($('#automation_form')[0] as HTMLFormElement).reset();
		$('#ra_id').val('');
		$('#delete_automation').hide().off('click');
		$('#schedule_warning_message').hide();
	};

	const deleteAutomation = async (rowData: { ra_id: number; ra_name: string }, hideForm = false) => {
		const confirmed = await confirmDialog({
			dialogTitle: 'Delete Automation',
			bodyText: `Are you sure you want to delete <em>"${htmlEsc(rowData.ra_name)}"</em>? This cannot be undone. Pending scheduled runs will be cancelled.`,
			confirmText: 'Delete',
			confirmStyle: 'danger',
		});
		if (!confirmed) return;

		try {
			const res = await ajaxPromise('/form/submit', {
				type: 'report_automation_delete',
				data: rowData.ra_id,
			});
			if (res.rc !== 'OK') throw res;

			automationsDt.ajax.reload();
			if (hideForm || +$('#ra_id').val() === rowData.ra_id) {
				resetAutomationForm();
				hideAutomationForm();
			}
			displayNotification('Automation', 'Automation deleted.', 'success');
		} catch (error) {
			logerror('automation delete', error);
			displayNotification('Automation', 'An error occurred while deleting this automation.', 'danger');
		}
	};

	const showAutomationForm = (data: any = null) => {
		if (data) { // Edit mode
			$('#form_title').text('Edit Automation');
			$('#ra_id').val(data.ra_id);
			$('#ra_name').val(data.ra_name);
			$('#ra_desc').val(data.ra_desc);
			$('#ra_to').val(data.ra_to);
			$('#ra_subject').val(data.ra_subject);
			$('#ra_message').val(data.ra_message);
			$('#ra_status').val(data.ra_status);

			// Populate scheduling fields
			if (data.ra_start_date) {
				$('#ra_start_date').val(data.ra_start_date);
			}
			if (data.ra_start_time) {
				$('#ra_start_time').val(data.ra_start_time);
			}
			if (data.ra_recurrence_type) {
				$('#ra_recurrence_type').val(data.ra_recurrence_type).trigger('change');
			}
			if (data.ra_recurrence_interval) {
				$('#ra_recurrence_interval').val(data.ra_recurrence_interval);
			}
			if (data.ra_end_date) {
				$('input[name="end_pattern"][value="end_date"]').prop('checked', true);
				$('#ra_end_date').val(data.ra_end_date).prop('disabled', false);
			} else if (data.ra_max_occurrences) {
				$('input[name="end_pattern"][value="after_occurrences"]').prop('checked', true);
				$('#ra_max_occurrences').val(data.ra_max_occurrences).prop('disabled', false);
			} else {
				$('input[name="end_pattern"][value="never"]').prop('checked', true);
			}

			// Populate recurrence pattern data
			if (data.ra_recurrence_pattern) {
				try {
					const pattern = JSON.parse(data.ra_recurrence_pattern);

					// Weekly pattern
					if (pattern.weekly_pattern) {
						$(`input[name="weekly_pattern"][value="${pattern.weekly_pattern}"]`).prop('checked', true).trigger('change');

						if (pattern.weekly_pattern === 'specific_days' && pattern.specific_days) {
							pattern.specific_days.forEach((day: number) => {
								$(`input[name="ra_recurrence_days[]"][value="${day}"]`).prop('checked', true);
							});
						}
					}

					// Monthly pattern
					if (pattern.monthly_pattern) {
						$(`input[name="monthly_pattern"][value="${pattern.monthly_pattern}"]`).prop('checked', true).trigger('change');

						if (pattern.monthly_pattern === 'specific_dates' && pattern.specific_dates) {
							pattern.specific_dates.forEach((date: number) => {
								$(`input[name="monthly_dates[]"][value="${date}"]`).prop('checked', true);
							});
						} else if (pattern.monthly_pattern === 'day_of_week') {
							if (pattern.monthly_week_position) {
								$('#monthly_week_position').val(pattern.monthly_week_position);
							}
							if (pattern.monthly_day_of_week) {
								$('#monthly_day_of_week').val(pattern.monthly_day_of_week);
							}
						}
					}

					// Yearly pattern
					if (pattern.yearly_pattern) {
						$(`input[name="yearly_pattern"][value="${pattern.yearly_pattern}"]`).prop('checked', true).trigger('change');

						if (pattern.yearly_pattern === 'specific_dates') {
							if (pattern.yearly_months) {
								pattern.yearly_months.forEach((month: number) => {
									$(`input[name="yearly_months[]"][value="${month}"]`).prop('checked', true);
								});
							}
							if (pattern.yearly_date) {
								$('#yearly_date').val(pattern.yearly_date);
							}
						}
					}
				} catch (error) {
					console.warn('Error parsing recurrence pattern:', error);
				}
			}

			$('#delete_automation').show().off('click').on('click', async () => {
				const raId = +$('#ra_id').val();
				if (!raId) return;
				await deleteAutomation({
					ra_id: raId,
					ra_name: $('#ra_name').val()?.toString().trim() || '',
				}, true);
			});
			$('#schedule_warning_message').show();
		} else { // insert mode
			$('#form_title').text('Create New Automation');
			resetAutomationForm();
			$('#ra_status').val(REPORT_AUTOMATION_ACTIVE);
			$('#ra_reportid').val(automationData.reportId);

			// Set default values for new automation
			$('#ra_start_date').val(new Date().toISOString().split('T')[0]);
			const now = new Date();
			now.setHours(now.getHours() + 1, 0, 0, 0);
			$('#ra_start_time').val(now.toTimeString().slice(0, 5));
			$('#ra_recurrence_type').val('none').trigger('change');
			$('#ra_recurrence_interval').val(1);
			$('input[name="end_pattern"][value="never"]').prop('checked', true);
		}

		// Update displays and preview
		updateWeeklyIntervalDisplay();
		updateSchedulePreview();
		$('#automation_form_container').slideDown();
	};

	const hideAutomationForm = () => $('#automation_form_container').slideUp();

	$('#automation_form').on('submit', async (e) => {
		e.preventDefault();

		// automation name
		if (!$('#ra_name').val()?.toString().trim()) {
			displayNotification('Automation', 'Please enter an automation name.', 'warning');
			return;
		}

		// email recipients
		if (!$('#ra_to').val()?.toString().trim()) {
			displayNotification('Automation', 'Please enter at least one email recipient.', 'warning');
			return;
		}

		// email subject
		if (!$('#ra_subject').val()?.toString().trim()) {
			displayNotification('Automation', 'Please enter an email subject.', 'warning');
			return;
		}

		// Validate scheduling fields
		if (!$('#ra_start_date').val()) {
			displayNotification('Automation', 'Please select a start date.', 'warning');
			return;
		}

		// start time
		if (!$('#ra_start_time').val()) {
			displayNotification('Automation', 'Please select a start time.', 'warning');
			return;
		}

		// status	
		if (!$('#ra_status').val()) {
			displayNotification('Automation', 'Please select a status.', 'warning');
			return;
		}

		const schedulingData = {
			ra_start_date: $('#ra_start_date').val(),
			ra_start_time: $('#ra_start_time').val(),
			ra_recurrence_type: $('#ra_recurrence_type').val(),
			ra_recurrence_interval: parseInt($('#ra_recurrence_interval').val() as string) || 1,
			ra_end_date: $('input[name="end_pattern"]:checked').val() === 'end_date' ? $('#ra_end_date').val() : null,
			ra_max_occurrences: $('input[name="end_pattern"]:checked').val() === 'after_occurrences' ? parseInt($('#ra_max_occurrences').val() as string) : null,
		};

		const recurrencePattern: any = {};
		const recurrenceType = $('#ra_recurrence_type').val();
		switch (recurrenceType) {
			case 'week':
				const weeklyPattern = $('input[name="weekly_pattern"]:checked').val();
				recurrencePattern.weekly_pattern = weeklyPattern;

				if (weeklyPattern === 'specific_days') {
					recurrencePattern.specific_days = $('input[name="ra_recurrence_days[]"]:checked').map((_, element) => parseInt($(element).val() as string)).get();

					// Validate that at least one day is selected
					if (recurrencePattern.specific_days.length === 0) {
						displayNotification('Automation', 'Please select at least one day of the week.', 'warning');
						return;
					}
				}
				break;

			case 'month':
				const monthlyPattern = $('input[name="monthly_pattern"]:checked').val();
				recurrencePattern.monthly_pattern = monthlyPattern;

				if (monthlyPattern === 'specific_dates') {
					recurrencePattern.specific_dates = $('input[name="monthly_dates[]"]:checked').map((_, element) => parseInt($(element).val() as string)).get();

					// Validate that at least one date is selected
					if (recurrencePattern.specific_dates.length === 0) {
						displayNotification('Automation', 'Please select at least one date of the month.', 'warning');
						return;
					}
				} else if (monthlyPattern === 'day_of_week') {
					recurrencePattern.monthly_week_position = $('#monthly_week_position').val();
					recurrencePattern.monthly_day_of_week = $('#monthly_day_of_week').val();
				}
				break;

			case 'year':
				const yearlyPattern = $('input[name="yearly_pattern"]:checked').val();
				recurrencePattern.yearly_pattern = yearlyPattern;

				if (yearlyPattern === 'specific_dates') {
					recurrencePattern.yearly_months = $('input[name="yearly_months[]"]:checked').map((_, element) => parseInt($(element).val() as string)).get();
					recurrencePattern.yearly_date = parseInt($('#yearly_date').val() as string);

					// Validate that at least one month is selected
					if (recurrencePattern.yearly_months.length === 0) {
						displayNotification('Automation', 'Please select at least one month.', 'warning');
						return;
					}
				}
				break;
			default:
				// For 'none', 'minute', 'hour', 'day' - no additional pattern data needed
				break;
		}

		// Validate end date if specified
		if (schedulingData.ra_end_date) {
			const startDate = new Date(schedulingData.ra_start_date as string);
			const endDate = new Date(schedulingData.ra_end_date as string);

			if (endDate <= startDate) {
				displayNotification('Automation', 'End date must be after the start date.', 'warning');
				return;
			}
		}

		// Validate max occurrences if specified
		if (schedulingData.ra_max_occurrences && schedulingData.ra_max_occurrences < 1) {
			displayNotification('Automation', 'Number of occurrences must be at least 1.', 'warning');
			return;
		}

		$('#save_automation_form').prop('disabled', true);
		const raId = $('#ra_id').val();
		try {
			const res = await ajaxPromise('/form/submit', {
				type: 'report_automation_save',
				data: {
					...(raId ? { ra_id: raId } : {}),
					ra_name: $('#ra_name').val(),
					ra_desc: $('#ra_desc').val(),
					ra_to: $('#ra_to').val(),
					ra_subject: $('#ra_subject').val(),
					ra_message: $('#ra_message').val(),
					ra_status: $('#ra_status').val(),
					ra_reportid: $('#ra_reportid').val(),
					ra_preview_msg: $('#schedule_preview').find('p').text(),
					...schedulingData,
					ra_recurrence_pattern: Object.keys(recurrencePattern).length > 0 ? JSON.stringify(recurrencePattern) : null,
				},
			});
			if (res.rc !== 'OK') throw res;

			resetAutomationForm();
			hideAutomationForm();
			automationsDt.ajax.reload();
			displayNotification('Automation', 'Automation saved successfully!', 'success');
		} catch (error) {
			logerror('automation save error', error);
			switch (error.rc) {
				case 'NO_VALID_EMAILS':
					displayNotification('Automation', 'Please enter at least one valid email recipient.', 'danger');
					break;
				case 'BAD_END_DATE':
					displayNotification('Automation', 'End date must be after start date', 'danger');
					break;
				case 'INVALID_RECURRENCE':
					displayNotification('Automation', 'Invalid recurrence pattern. Please try again.', 'danger');
					break;
				default:
					displayNotification('Automation', 'Error saving automation. Please try again.', 'danger');
			}
		}

		$('#save_automation_form').prop('disabled', false);
	});

	$('#print_automation_form').off('click').on('click', function () {
		let title = $('#ra_name').val();
		let config = {
			title: title,
			callback: () => {
				const $target = $('#automation_form_container');
				let $body = $target.clone();
				$body.find('#automation_form_controls').remove();
				$body.find('.panel-heading').remove();
				$body.find('.panel').css('border', 'none');
				$body.find('#form_title').hide();
				$body.find('input').each((_, element) => {
					$(element).attr('value', $(element).val().toString());
				});
				$target.find('select').each((_, element) => {
					const $t = $body.find('#' + $(element).attr('id'));
					$t.val($(element).val());
					$t.find('option:selected').attr('selected', 'selected');
				});
				$body.find('textarea').each((_, element) => {
					$(element).html($(element).val().toString());
				});
				return $body;
			},
		};
		printThis(config);
		ajaxPromise('/form/submit', { type: 'report_automation_print', data: { id: $('#ra_id').val() } }).catch((error) => {
			logerror('automation form print', error);
		});

		return false;
	});

	$('#cancel_automation_form').on('click', () => hideAutomationForm());

	// Make showAutomationForm globally available -- so we can call it from inline HTML
	(window as any).showAutomationForm = showAutomationForm;

	initAutomationsTable();

	let scheduleDt: DataTables.Api | null = null;
	const showScheduleModal = (automationId: number) => {
		if (scheduleDt !== null) {
			scheduleDt.destroy();
			scheduleDt = null;
			$('#report_automation_schedule_table tbody').off('click', 'tr');
		}

		const statusMap = {
			[REPORT_SCHEDULE_PENDING]: {
				label: 'Pending',
				className: 'label-warning',
			},
			[REPORT_SCHEDULE_RUNNING]: {
				label: 'Running',
				className: 'label-info',
			},
			[REPORT_SCHEDULE_COMPLETED]: {
				label: 'Completed',
				className: 'label-success',
			},
			[REPORT_SCHEDULE_FAILED]: {
				label: 'Failed',
				className: 'label-danger',
			},
			[REPORT_SCHEDULE_PARTIAL_COMPLETED]: {
				label: 'Partial Completion',
				className: 'label-warning',
			},
		};

		$('#report_automation_schedule_filter_container .chosen').chosen({ width: '100%' });
		toggleSlide($('#report_automation_schedule_filter_toggle'), $('#report_automation_schedule_filter_container'));

		const dateFilters = ['#report_automation_schedule_filter_scheduled', '#report_automation_schedule_filter_started', '#report_automation_schedule_filter_completed'];
		dateFilters.forEach(filter => initDateFilter(filter));

		let filtersChangeHandler = true;
		$('#report_automation_schedule_filter_container').on('change', () => {
			if (!filtersChangeHandler) return;
			checkFiltersChosenChanged();
			scheduleDt.ajax.reload();
		});

		$('#report_automation_schedule_filter_reset')
			.off('click')
			.on('click', () => {
				filtersChangeHandler = false;
				$('#report_automation_schedule_filter_container').trigger('reset');
				$('#report_automation_schedule_filter_container .chosen').trigger('change').trigger('chosen:updated');
				checkFiltersChosenChanged();
				scheduleDt.ajax.reload(null, false);
				filtersChangeHandler = true;
			});

		const getFilters = () => ({
			status: $('#report_automation_schedule_filter_status').val(),
			schedule_date: getDateFilter('#report_automation_schedule_filter_scheduled'),
			started_date: getDateFilter('#report_automation_schedule_filter_started'),
			completed_date: getDateFilter('#report_automation_schedule_filter_completed'),
		});

		const checkFiltersChosenChanged = () => $('#report_automation_schedule_filter_container select.chosen').each((_, element) => checkChosenChanged($(element)));

		const dtOptions: DataTables.Settings = {
			ajax: {
				url: '/data/report_automations_schedules_load',
				data: (postData: any) => ({
					...postData,
					automationId,
					filters: getFilters()
				}),
			},
			columns: [
				{
					title: 'Scheduled',
					data: 'ras_scheduled_at_pretty',
				},
				{
					title: 'Started',
					data: 'ras_started_at_pretty',
				},
				{
					title: 'Completed',
					data: 'ras_completed_at_pretty',
				},
				{
					title: 'Recipients',
					data: 'ra_to',
					render: (data: string, _, row: any) => {
						const allEmails = data.split(/[,\n]/).map(email => email.trim()).filter(email => email);
						const failedEmails = row.ras_failed_emails ?
							row.ras_failed_emails.split(/[,\n]/).map(email => email.trim().toLowerCase()).filter(email => email) : [];

						// Separate failed and successful emails
						const failed = allEmails.filter(email => failedEmails.includes(email.toLowerCase()));
						const successful = allEmails.filter(email => !failedEmails.includes(email.toLowerCase()));

						const prioritizedEmails = [...failed, ...successful];
						if (prioritizedEmails.length <= 2) {
							return prioritizedEmails.map(email => {
								const isFailed = failedEmails.includes(email.toLowerCase());
								return isFailed ?
									`<span class="text-danger">${htmlEsc(email)} (failed)</span>` :
									htmlEsc(email);
							}).join(', ');
						}

						const displayEmails = prioritizedEmails.slice(0, 2).map(email => {
							const isFailed = failedEmails.includes(email.toLowerCase());
							return isFailed ?
								`<span class="text-danger">${htmlEsc(email)} (failed)</span>` :
								htmlEsc(email);
						});

						return `${displayEmails.join(', ')} <em>(+${prioritizedEmails.length - 2} more)</em>`;
					},
				},
				{
					title: 'Status',
					data: 'ras_status_pretty',
					searchable: false,
				}
			],
			buttons: [
				{
					text: '<i class="fa fa-file-csv me-2"></i> Export',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const filters = getFilters();
						const $btn = $(target);
						$btn.prop('disabled', true);

						post('/export', {
							type: 'report_automation_schedule',
							data: JSON.stringify({
								automationId,
								...filters
							}),
						});

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
				{
					text: '<i class="fa fa-print me-2"></i> Print',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const filters = getFilters();
						const $btn = $(target);
						$btn.prop('disabled', true);

						const params = {
							...scheduleDt.ajax.params(),
							automationId,
							filters,
						};

						post('/printout/report_automation_schedule', {
							params: JSON.stringify(params)
						}, '_blank');

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
			],
			columnDefs: [
				{ targets: 0, responsivePriority: 1 },
				{ targets: -1, responsivePriority: 2 },
				{ targets: '_all', render: (val) => htmlEsc(val) },
			],
			order: [[2, 'desc']],
			responsive: { details: false },
		};

		scheduleDt = $('#report_automation_schedule_table').DataTable(dtOptions);

		$('#report_automation_schedule_table tbody').on('click', 'tr', ({ target }) => {
			const $tr = $(target).closest('tr');
			const row = scheduleDt.row($tr);
			const scheduleData = row.data();

			if (row.child.isShown()) {
				row.child.hide();
				$tr.removeClass('shown');
			} else {
				const details = createScheduleDetailsView(scheduleData);
				row.child(details).show();
				$tr.addClass('shown');
			}
		});

		$('#report_automation_schedule_table').on('click', '.automation_detail_print', ({ target }) => {
			const $tr = $(target).closest('tr');
			const config = {
				title: 'Automation Schedule Details',
				callback: () => {
					const $trClone = $tr.clone();
					$trClone.prepend('<h3>Automation Schedule Details</h3>');
					$trClone.find('.automation_detail_print').remove();
					$trClone.append($('#copyright_footer').clone().css('text-align', 'center'));
					return $trClone;
				},
			};
			printThis(config);

			const postData = {
				type: 'report_automation_schedule_print',
				data: { automationId },
			};
			ajaxPromise('/form/submit', postData).catch((error) => {
				logerror('automation detail print', error);
			});
		});

		$('#report_bookmark_schedule').modal();
	}

	type ScheduleData = {
		ras_scheduled_at: string;
		ras_started_at_pretty: string;
		ras_completed_at_pretty: string;
		ras_scheduled_at_pretty: string;
		ras_failed_emails: string;
		ras_status: number;
		ra_to: string;
		ra_subject: string;
		ra_message: string;
	};
	const createScheduleDetailsView = (scheduleData: ScheduleData) => {

		const renderRecipients = () => {
			const allRecipients = scheduleData?.ra_to ? scheduleData.ra_to
				.split(/[,\n]/) // split on comma or newline
				.map(email => email.trim()?.toLowerCase()) // trim whitespace and convert to lowercase
				.filter(Boolean) : []; // filter out empty strings

			const failedEmails = scheduleData?.ras_failed_emails ? scheduleData.ras_failed_emails
				.split(/[,\n]/) // split on comma or newline
				.map(email => email.trim()?.toLowerCase()) // trim whitespace and convert to lowercase
				.filter(Boolean) : []; // filter out empty strings

			if (allRecipients.length === 0) return 'N/A';

			return allRecipients.map((email, index) => {
				const isFailed = failedEmails.includes(email);
				return (
					<span key={index}>
						{index > 0 ? ', ' : ''}
						<span className={isFailed ? 'text-danger' : ''}>
							{email}{isFailed ? ' (failed)' : ''}
						</span>
					</span>
				);
			});
		};

		const processSubject = (subject: string, scheduledDate: string) => {
			if (!subject || !scheduledDate) return subject || 'N/A';

			const parsedDate = new Date(scheduledDate);
			const dateOnly = parsedDate.toISOString().split('T')[0];

			return subject.replace(/\{date\}/g, dateOnly);
		};

		return (
			<div>
				<div className='d-flex justify-content-end'>
					<button className="btn btn-xs btn-primary automation_detail_print">Print</button>
				</div>
				<div className="schedule-details-container" >
					<div className="row">
						<div className="col-md-6">
							<h5>
								<i className="fa fa-info-circle me-2"></i>
								Schedule Information
							</h5>
							<div className="table-responsive">
								<table className="table table-sm table-borderless" >
									<tbody>
										<tr>
											<td>
												<strong>Scheduled At:</strong>
											</td>
											<td>
												{scheduleData?.ras_scheduled_at_pretty || 'N/A'}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Started At:</strong>
											</td>
											<td>
												{scheduleData?.ras_started_at_pretty || 'N/A'}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Completed At:</strong>
											</td>
											<td>
												{scheduleData?.ras_completed_at_pretty || 'N/A'}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div className="col-md-6">
							<h5 style={{
								marginTop: 0,
								marginBottom: '15px',
								fontWeight: 600
							}}>
								<i className="fa fa-envelope me-2"></i>
								Delivery Details
							</h5>
							<div className="table-responsive">
								<table className="table table-sm table-borderless" >
									<tbody>
										<tr>
											<td>
												<strong>Recipients:</strong>
											</td>
											<td>
												{renderRecipients()}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Subject:</strong>
											</td>
											<td>
												{processSubject(scheduleData?.ra_subject, scheduleData?.ras_scheduled_at) || 'N/A'}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Message:</strong>
											</td>
											<td>
												{scheduleData?.ra_message || ''}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};
};

if ($('#automation_form').length == 1) initReportAutomation();

//On print window
if ($('#report_automation_schedule_printout').length == 1) {
	const deployPrintOut = async () => {
		const params = JSON.parse(atob($('#report_automation_schedule_printout').data('params')));

		try {
			const postData = {
				automationId: params.automationId,
				filters: {
					...params.filters,
					mode: DATATABLE_ALL,
				},
			};

			const res = await ajaxPromise('/data/report_automations_schedules_load', postData);
			$('#spinner').show();

			const table = (
				<table className="table table-condensed table-striped" style="width: 100%;">
					<thead>
						<tr>
							{res.headers.map((col) => (
								<th>{col}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{res.data.map((row, index) => (
							<tr className={index % 2 == 0 ? 'odd' : 'even'} style="border-bottom: 1px solid #d0d0d0;">
								{row.map((cell) => (
									<td>{cell != null ? cell : ''}</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			);
			$('#report_automation_schedule_printout').append(table);
			$('#report_automation_schedule_printout_total').html(`${res.recordsTotal} records`);

			setTimeout(() => {
				$('#spinner').hide();
				window.print();
			}, 1000);
		}
		catch (error) {
			displayNotification('Report Automation Schedule', 'There was an error loading the data.', 'danger');
			logerror('report automation schedule get error [ajax]', error);
		}
	};

	deployPrintOut();
}

if ($('#report_automations_printout').length == 1) {
	const deployAutomationsPrintOut = async () => {
		const params = JSON.parse(atob($('#report_automations_printout').data('params')));

		try {
			const postData = {
				report_id: params.report_id,
				filters: {
					mode: DATATABLE_ALL,
				},
			};

			const res = await ajaxPromise('/data/report_automations_load', postData);
			$('#spinner').show();

			const table = (
				<table className="table table-condensed table-striped" style="width: 100%;">
					<thead>
						<tr>
							{res.headers.map((col) => (
								<th>{col}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{res.data.map((row, index) => (
							<tr className={index % 2 == 0 ? 'odd' : 'even'} style="border-bottom: 1px solid #d0d0d0;">
								{row.map((cell) => (
									<td>{cell != null ? cell : ''}</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			);
			$('#report_automations_printout').append(table);
			$('#report_automations_printout_total').html(`${res.recordsTotal} records`);

			setTimeout(() => {
				$('#spinner').hide();
				window.print();
			}, 1000);
		}
		catch (error) {
			displayNotification('Report Automations', 'There was an error loading the data.', 'danger');
			logerror('report automations get error [ajax]', error);
		}
	};

	deployAutomationsPrintOut();
}